<template>
  <d2-container>
    <template slot="header">
      <el-select
        v-model="listQuery.channelType"
        clearable
        placeholder="渠道类型"
        size="small"
        style="width: 140px; margin-right: 10px;"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="图片" value="image"></el-option>
        <el-option label="视频" value="video"></el-option>
      </el-select>
      <el-input
        v-model="listQuery.keyword"
        clearable
        size="small"
        placeholder="模型/备注"
        style="width: 240px; margin-right: 10px;"
        @keyup.enter.native="getSearch"
      ></el-input>
      <el-select
        v-model="listQuery.quality"
        clearable
        placeholder="Quality"
        size="small"
        style="width: 130px; margin-right: 10px;"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="low" value="low"></el-option>
        <el-option label="medium" value="medium"></el-option>
        <el-option label="high" value="high"></el-option>
        <el-option label="xhigh" value="xhigh"></el-option>
        <el-option label="max" value="max"></el-option>
        <el-option label="* 通配" value="*"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getSearch">搜索</el-button>
      <el-button type="success" size="small" icon="el-icon-refresh" @click="refreshCache">刷新</el-button>
      <el-button type="primary" size="small" icon="el-icon-circle-plus" @click="addCard">新增规则</el-button>
    </template>

    <el-table
      size="small"
      stripe
      border
      :data="displayList"
      v-loading="listLoading"
    >
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="channelType" label="类型" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.channelType === 'video' ? 'warning' : 'success'">
            {{ scope.row.channelType === 'video' ? '视频' : '图片' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="model" label="模型" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="画质" width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.channelType === 'image' ? formatValue(scope.row.imageSize) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Quality" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.channelType === 'image' ? formatValue(scope.row.quality) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="时长" width="90" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.channelType !== 'video'">-</span>
          <span v-else>{{ scope.row.duration === -1 ? '*' : scope.row.duration }}</span>
        </template>
      </el-table-column>
      <el-table-column label="档位" width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.channelType === 'video' ? formatValue(scope.row.mode) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="声音" width="90" align="center">
        <template slot-scope="scope">
          {{ scope.row.channelType === 'video' ? formatSound(scope.row.sound) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="价格" width="100" align="center">
        <template slot-scope="scope">
          <span class="price-highlight">{{ formatPrice(scope.row.price) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="priority" label="优先级" width="90" align="center"></el-table-column>
      <el-table-column label="启用" width="90" align="center">
        <template slot-scope="scope">
          <el-switch :value="!!scope.row.enabled" @change="toggleEnabled(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center"></el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="editCard(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogStatus" :visible.sync="dialogFormVisible" width="720px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="渠道类型" prop="channelType">
              <el-select v-model="form.channelType" style="width: 100%;" @change="onChannelTypeChange">
                <el-option label="图片" value="image"></el-option>
                <el-option label="视频" value="video"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="模型" prop="model">
              <el-input v-model="form.model" placeholder="如 nano-banana-2，* 表示通配"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="价格" prop="price" class="price-form-item">
              <el-input-number v-model="form.price" :min="0.01" :precision="2" :step="1" style="width: 100%;" class="price-input"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12" v-if="form.channelType === 'image'">
          <el-col :span="8">
            <el-form-item label="画质(imageSize)">
              <el-select v-model="form.imageSize" style="width: 100%;">
                <el-option label="* (通配)" value="*"></el-option>
                <el-option label="1k" value="1k"></el-option>
                <el-option label="2k" value="2k"></el-option>
                <el-option label="4k" value="4k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Quality">
              <el-select v-model="form.quality" style="width: 100%;">
                <el-option label="* (通配)" value="*"></el-option>
                <el-option label="low" value="low"></el-option>
                <el-option label="medium" value="medium"></el-option>
                <el-option label="high" value="high"></el-option>
                <el-option label="xhigh" value="xhigh"></el-option>
                <el-option label="max" value="max"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="优先级">
              <el-input-number v-model="form.priority" :min="0" :step="1" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12" v-if="form.channelType === 'video'">
          <el-col :span="8">
            <el-form-item label="时长(duration)">
              <el-input-number v-model="form.duration" :min="-1" :step="1" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="档位(mode)">
              <el-select v-model="form.mode" style="width: 100%;">
                <el-option label="* (通配)" value="*"></el-option>
                <el-option label="std" value="std"></el-option>
                <el-option label="pro" value="pro"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="声音(sound)">
              <el-select v-model="form.sound" style="width: 100%;">
                <el-option label="* (通配)" value="*"></el-option>
                <el-option label="mute(无声)" value="mute"></el-option>
                <el-option label="sound(有声)" value="sound"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="优先级" v-if="form.channelType === 'video'">
              <el-input-number v-model="form.priority" :min="0" :step="1" style="width: 100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用">
              <el-switch v-model="form.enabled"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addOrUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  addChannelModelPrice,
  getChannelModelPriceList,
  refreshChannelModelPriceCache,
  updateChannelModelPrice
} from '@/api/merchant/service/channel'

export default {
  name: 'channelPriceManager',
  data () {
    return {
      list: [],
      listLoading: false,
      dialogFormVisible: false,
      dialogStatus: '新增价格规则',
      listQuery: {
        channelType: '',
        keyword: '',
        quality: ''
      },
      form: this.getDefaultForm(),
      rules: {
        channelType: [
          { required: true, message: '请选择渠道类型', trigger: 'change' }
        ],
        model: [
          { required: true, message: '请输入模型，通配请填*', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    displayList () {
      const keyword = (this.listQuery.keyword || '').trim().toLowerCase()
      return this.list.filter(item => {
        if (this.listQuery.channelType && item.channelType !== this.listQuery.channelType) {
          return false
        }
        if (!keyword) {
          return true
        }
        const text = `${item.model || ''} ${item.quality || ''} ${item.remark || ''}`.toLowerCase()
        return text.indexOf(keyword) > -1
      })
    }
  },
  created () {
    this.getSearch()
  },
  methods: {
    getDefaultForm () {
      return {
        id: null,
        channelType: 'image',
        model: '*',
        imageSize: '1k',
        quality: '*',
        duration: 5,
        mode: 'std',
        sound: 'mute',
        price: 10,
        enabled: true,
        priority: 100,
        remark: ''
      }
    },
    normalizeList (res) {
      if (Array.isArray(res)) {
        return res
      }
      if (res && Array.isArray(res.records)) {
        return res.records
      }
      if (res && Array.isArray(res.list)) {
        return res.list
      }
      return []
    },
    getSearch () {
      this.listLoading = true
      getChannelModelPriceList({
        channelType: this.listQuery.channelType,
        quality: this.listQuery.quality
      }).then(res => {
        this.list = this.normalizeList(res)
      }).finally(() => {
        this.listLoading = false
      })
    },
    addCard () {
      this.dialogStatus = '新增价格规则'
      this.form = this.getDefaultForm()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    editCard (row) {
      this.dialogStatus = '编辑价格规则'
      this.form = {
        id: row.id,
        channelType: row.channelType || 'image',
        model: row.model || '*',
        imageSize: row.imageSize || '*',
        quality: row.quality || '*',
        duration: this.toNumber(row.duration, -1),
        mode: row.mode || '*',
        sound: row.sound || '*',
        price: this.toNumber(row.price, 0),
        enabled: !!row.enabled,
        priority: this.toNumber(row.priority, 100),
        remark: row.remark || ''
      }
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    toNumber (value, defaultValue) {
      const n = Number(value)
      return Number.isNaN(n) ? defaultValue : n
    },
    onChannelTypeChange (type) {
      if (type === 'image') {
        this.form.imageSize = this.form.imageSize || '1k'
        this.form.quality = this.form.quality || '*'
        this.form.duration = -1
        this.form.mode = '*'
        this.form.sound = '*'
      } else {
        this.form.imageSize = '*'
        this.form.quality = '*'
        this.form.duration = this.form.duration === -1 ? 5 : this.form.duration
        this.form.mode = this.form.mode === '*' ? 'std' : this.form.mode
        this.form.sound = this.form.sound === '*' ? 'mute' : this.form.sound
      }
    },
    buildPayload () {
      const payload = {
        id: this.form.id,
        channelType: this.form.channelType,
        model: (this.form.model || '').trim(),
        price: this.form.price,
        enabled: this.form.enabled,
        priority: this.form.priority,
        remark: (this.form.remark || '').trim()
      }
      if (payload.channelType === 'image') {
        payload.imageSize = this.form.imageSize || '*'
        payload.quality = this.form.quality || '*'
        payload.duration = -1
        payload.mode = '*'
        payload.sound = '*'
      } else {
        payload.imageSize = '*'
        payload.quality = '*'
        payload.duration = this.form.duration
        payload.mode = this.form.mode || '*'
        payload.sound = this.form.sound || '*'
      }
      return payload
    },
    addOrUpdate () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        const payload = this.buildPayload()
        const request = payload.id ? updateChannelModelPrice(payload) : addChannelModelPrice(payload)
        request.then(() => {
          this.$message.success(payload.id ? '更新成功' : '新增成功')
          this.dialogFormVisible = false
          this.getSearch()
        })
      })
    },
    toggleEnabled (row) {
      const payload = {
        id: row.id,
        channelType: row.channelType,
        model: row.model,
        imageSize: row.imageSize,
        quality: row.quality,
        duration: row.duration,
        mode: row.mode,
        sound: row.sound,
        price: row.price,
        enabled: !row.enabled,
        priority: row.priority,
        remark: row.remark
      }
      updateChannelModelPrice(payload).then(() => {
        this.$message.success(payload.enabled ? '已启用' : '已禁用')
        this.getSearch()
      })
    },
    refreshCache () {
      refreshChannelModelPriceCache().then(() => {
        this.$message.success('价格规则已刷新')
        this.getSearch()
      })
    },
    formatValue (v) {
      if (v === null || v === undefined || v === '') {
        return '-'
      }
      return `${v}`
    },
    formatPrice (value) {
      const n = Number(value)
      if (Number.isNaN(n)) {
        return this.formatValue(value)
      }
      return n.toFixed(2)
    },
    formatSound (sound) {
      const value = `${sound || ''}`.toLowerCase()
      if (value === 'mute') {
        return '无声'
      }
      if (value === 'sound') {
        return '有声'
      }
      if (value === '*') {
        return '*'
      }
      return this.formatValue(sound)
    }
  }
}
</script>

<style scoped>
.price-highlight {
  display: inline-block;
  min-width: 58px;
  padding: 2px 8px;
  border-radius: 12px;
  background: #fff1f0;
  color: #f56c6c;
  font-weight: 700;
}

/deep/ .price-form-item .el-form-item__label {
  color: #f56c6c;
  font-weight: 700;
}

/deep/ .price-input .el-input__inner {
  border-color: #f56c6c;
  background: #fff7f6;
}
</style>
